import { UserRoleToBroadcastMapping } from '@goldcast/api/backend';

import { ExtendedRole, Speaker, State } from './types';

const getters = {
  getSpeakers(state: State): Array<Speaker> {
    const speakers = Object.values(state.speakers);
    return speakers.sort((a, b) => a.rank - b.rank);
  },
  getSpeakerById: (state: State) => (speakerId: string) => state.speakers[speakerId],
  getSpeakerRolesBySpeakerId:
    (state: State) =>
    (speakerId?: number): string[] => {
      if (!speakerId || !state.speakers[speakerId]) {
        return [state.defaultSpeakerRole?.role.name.toLowerCase() ?? ''];
      }

      const speaker = state.speakers[speakerId];

      const speakerRoles: string[] = [];

      speaker.permission_roles?.forEach((permissionRole: UserRoleToBroadcastMapping) => {
        speakerRoles.push(permissionRole.role.name.toLowerCase());
      });

      if (speakerRoles.length === 0) {
        return [state.defaultSpeakerRole?.role.name.toLowerCase() ?? ''];
      }

      return speakerRoles;
    },
  getSpeakerRoleOptions: (state: State): ExtendedRole[] => {
    const speakerRoleOptions: ExtendedRole[] = Object.values(state.speakerRolesMap);

    speakerRoleOptions.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));

    return speakerRoleOptions;
  },
  getSystemUserRoles: (state: State): ExtendedRole[] => {
    const systemUserRoles: ExtendedRole[] = Object.values(state.systemUserRolesMap);

    systemUserRoles.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));

    return systemUserRoles;
  },
  getSpeakerRoleForBroadcast:
    (state: State, getters: any) =>
    (payload: { speakerId?: number; broadcastId: string; roleName?: string }): ExtendedRole | null => {
      const { speakerId, broadcastId, roleName } = payload || {};
      const speakerRoleOptions: ExtendedRole[] = getters.getSpeakerRoleOptions;

      if (!speakerId || !broadcastId || !state.speakers[speakerId]) {
        return state.defaultSpeakerRole?.role || speakerRoleOptions[speakerRoleOptions.length - 1];
      }

      if (roleName) {
        return speakerRoleOptions.find(role => role.name === roleName) || null;
      }

      const speaker = state.speakers[speakerId];

      const selectedSpeakerRole =
        speaker?.permission_roles?.find(role => role.broadcasts.includes(broadcastId))?.role || ({} as ExtendedRole);

      if (!selectedSpeakerRole?.id) {
        return state.defaultSpeakerRole?.role || speakerRoleOptions[speakerRoleOptions.length - 1];
      }

      return selectedSpeakerRole;
    }
};

export default getters;
